import { render } from "./message-rating-star.vue?vue&type=template&id=481d75e6&scoped=true&ts=true"
import script from "./message-rating-star.vue?vue&type=script&lang=ts"
export * from "./message-rating-star.vue?vue&type=script&lang=ts"

import "./message-rating-star.vue?vue&type=style&index=0&id=481d75e6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481d75e6"]])

export default __exports__